import _sfc_main from './popover.vue2.js';
/* empty css            */
import _export_sfc from '../../_virtual/_plugin-vue_export-helper.js';

const Popover = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-4eb0de56"]]);

export { Popover as default };
//# sourceMappingURL=popover.js.map
